/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { Tabs, Tab } from '@celltrak/ui-components';

import ProfileInfo from '../ProfileInfo/ProfileInfo';
import CredentialsTab from '../CredentialsTab';

const AgenciesTabs = () => {
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <Tabs activeTab={activeTab} onSelect={tab => setActiveTab(tab)} fullHeight>
      <Tab title="Profile" tabKey="profile" fullHeight>
        <ProfileInfo />
      </Tab>
      <Tab title="Credentials" tabKey="credentials" fullHeight>
        <CredentialsTab />
      </Tab>
    </Tabs>
  );
};

export default AgenciesTabs;
